import resolveToArray from './resolveToArray';
/**
 * Normalize all white-space characters and remove trailing ones received text.
 * @example
 * normalizeWhiteSpaces(' What exactly is it?   ');
 * //=> "What exactly is it?"
 *
 * normalizeWhiteSpaces('Hi,   how is \r\n everything  \t?');
 * //=> 'Hi, how is everything ?'
 *
 * normalizeWhiteSpaces`It is ${temperature}\n  degree\r outside.  `
 * //=> 'It is 25 degree outside.'
 * @param {TemplateStringsArray | string} partsOrText
 * @param {unknown[]} values
 * @returns {string}
 */
function normalizeWhiteSpaces(partsOrText) {
    var values = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        values[_i - 1] = arguments[_i];
    }
    return resolveToArray(partsOrText)
        .reduce(function (text, part, index) { return text + values[index - 1] + part; })
        .replace(/\s+/g, ' ')
        .trim();
}
export default normalizeWhiteSpaces;
//# sourceMappingURL=normalizeWhiteSpaces.js.map